var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"el-icon-caret-top",staticStyle:{"color":"#1e88e5"}})}
var staticRenderFns = []

export { render, staticRenderFns }